module.exports = __webpack_public_path__ + "img/zpsO96_YFj-TuJx4JXAi0.8044ee2d.svg";